import {Injectable} from '@angular/core'
import type {MonitoringTrace} from '@models/monitoring/monitoring-trace'
import {MONITORING_SINK_URL_KEY, type MonitoringSink} from './monitoring-sink'

@Injectable({providedIn: 'root'})
export class HttpMonitoringSink implements MonitoringSink {
  async enqueue(trace: MonitoringTrace): Promise<void> {
    const url = localStorage.getItem(MONITORING_SINK_URL_KEY)
    if (!url) {
      return
    }
    await fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(trace),
      keepalive: true,
    })
  }
}
